import React from "react";

export interface IContainerMeasureModel {
  uuid: string;
  name: string
  height: number
  width: number
  depth: number
  availableCount: number
  hasAvailableContainers: boolean;
  dimensionText: React.ReactNode;
}


export class ContainerMeasureModel implements IContainerMeasureModel {
  uuid: string;
  name: string
  height: number
  width: number
  depth: number
  availableCount: number;
  hasAvailableContainers: boolean;
  dimensionText: React.ReactNode;

  constructor(data: IContainerMeasureModel) {
    this.uuid = data.uuid;
    this.name = data.name;
    this.height = data.height;
    this.width = data.width;
    this.depth = data.depth;
    this.availableCount = data.availableCount;
    this.hasAvailableContainers = data.availableCount > 0;
    this.dimensionText = (<>{this.name}<br />  A: {data.height} x  L: {data.width} x  P: {data.depth}</>)
  }
}